import React from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const LARGE_NAME_FONTS = [
  "Playfair Display, serif",
  "Cinzel Decorative, serif",
];


const Nophotocover = ({onScrollClick,details,showScrollIndicator,hideScrollIndicator}) => {

   const isLargeNameFont = LARGE_NAME_FONTS.includes(
  details?.nameFontStyle
);


  const groomNameBanner=()=>{
    return( <h3 
        className={`cover-name ${
        isLargeNameFont ? "cover-name--compact" : ""
      }`}
    style={{fontFamily:details.nameFontStyle}}>{ details?.groomName}</h3>)
  }

   const brideNameBanner=()=>{
    return( <h3 
         className={`cover-name ${
        isLargeNameFont ? "cover-name--compact" : ""
      }`}
    style={{fontFamily:details.nameFontStyle}}>{ details?.brideName}</h3>)
  }

   const coverFlowerBaseUrl =
  "https://res.cloudinary.com/depixc8dq/image/upload/v1792871412/aamantran%20assets/theme1coverflower_xkpudx.png";

const getOptimizedFlowerUrl = (width) =>
  coverFlowerBaseUrl.replace(
    "/upload/",
    `/upload/f_auto,q_auto,w_${width}/`
  );

const coverFlowerSrcSet = `
  ${getOptimizedFlowerUrl(160)} 160w,
  ${getOptimizedFlowerUrl(320)} 320w,
  ${getOptimizedFlowerUrl(640)} 640w
`;

  return (
    <section className='cover no-photo-cover cover-animate'>
      <picture>
    <source
      media="(min-width:768px)"
      srcSet={`
        https://res.cloudinary.com/depixc8dq/image/upload/w_1080/v1783947737/aamantran%20assets/Theme1deskbg_wi33cl.jpg 1080w,
        https://res.cloudinary.com/depixc8dq/image/upload/w_1920/v1783947737/aamantran%20assets/Theme1deskbg_wi33cl.jpg 1920w
      `}
      sizes="100vw"
    />

    <img
      className="cover-bg-image"
      src="https://res.cloudinary.com/depixc8dq/image/upload/v1783859458/aamantran%20assets/Theme1mobilebg_uia4ci.jpg"
      loading="lazy"
      srcSet={`
        https://res.cloudinary.com/depixc8dq/image/upload/w_320/v1783859458/aamantran%20assets/Theme1mobilebg_uia4ci.jpg 320w,
        https://res.cloudinary.com/depixc8dq/image/upload/w_640/v1783859458/aamantran%20assets/Theme1mobilebg_uia4ci.jpg 640w,
        https://res.cloudinary.com/depixc8dq/image/upload/w_1080/v1783859458/aamantran%20assets/Theme1mobilebg_uia4ci.jpg 1080w
      `}
      sizes="100vw"
      alt="cover background"
    />
  </picture>

       <div className="no-photo-bg-card">
        {/* <img src="/theme1coverflower.png" 
          className="card-flower card-flower-top"
        alt="cover-flower"  /> */}

         <img
  src={getOptimizedFlowerUrl(320)}
  srcSet={coverFlowerSrcSet}
  sizes="(max-width: 480px) 160px, (max-width: 768px) 320px, 320px"
  className="card-flower card-flower-top"
  alt="Cover flower"
/>
 
   <div className="cover-details">
   <span className="no-photo-cover-content">
  We are honored to welcome you to the {details?.functionType || "wedding"} ceremony of
</span>
         {/* <span className="no-photo-cover-content">
  {details?.userCode === "q8ts9r1c0"
    ? "We are honoured to welcome you to the engagement ceremony of"
    : "We are honoured to welcome you to the wedding ceremony of"}
</span> */}
           <div className="cover-name-wrapper">
              {details?.displayOrder==="groomFirst" ?<>
              {groomNameBanner()}
              <span 
                 className={`cover-and ${
        isLargeNameFont ? "cover-and--compact" : ""
      }`}
              
              style={{fontFamily:details.nameFontStyle}}>&</span>
              {brideNameBanner()}
              </>:<>
   {brideNameBanner()}
              <span 
                 className={`cover-and ${
        isLargeNameFont ? "cover-and--compact" : ""
      }`}
              
              style={{fontFamily:details.nameFontStyle}}>&</span>
               {groomNameBanner()}

              </>}
           </div>
                   {details?.hashtag && (
    <div className="cover-hashtag">#{details.hashtag}</div>
)}
       </div>

     {showScrollIndicator && (
      <div className="scroll-indicator" onClick={onScrollClick}>

      </div>
     )}
                  {showScrollIndicator && (<div  className={`scroll-indicator ${ hideScrollIndicator ? "hide" : ""}`} onClick={onScrollClick}>
            <ExpandMoreIcon className='scroll-indication-icon' />
          <span>SCROLL</span>
        </div>) }

   {/* <img
      src="/theme1coverflower.png"
      alt=""
      className="card-flower card-flower-bottom"
    /> */}
      <img
  src={getOptimizedFlowerUrl(320)}
  srcSet={coverFlowerSrcSet}
  sizes="(max-width: 480px) 160px, (max-width: 768px) 320px, 320px"
  alt=""
  className="card-flower card-flower-bottom"
/>
       </div>
    </section>
  )
}

export default Nophotocover